import { render, staticRenderFns } from "./InstitutionModification.vue?vue&type=template&id=ce9badca&scoped=true"
import script from "./InstitutionModification.vue?vue&type=script&lang=js"
export * from "./InstitutionModification.vue?vue&type=script&lang=js"
import style0 from "./InstitutionModification.vue?vue&type=style&index=0&id=ce9badca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce9badca",
  null
  
)

export default component.exports